import _ from 'lodash';
import {
    FETCH_MTOKNA_MANUAL_INVOICES,
    CLEAN_MTOKNA_MANUAL_INVOICES,
    PAID_MTOKNA_MANUAL_INVOICE,
    CHANGE_MTOKNA_MANUAL_INVOICE_SETTINGS,
} from './types';
import {__, request} from '../functions';

export const fetchMtoknaManualInvoices = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/mtokna/manualInvoices', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_MANUAL_INVOICES, payload: data });
    });
};

export const paidMtoknaManualInvoice = (screen, id) => {
    return dispatch => request(`/mtokna/paidManualOrder/${id}`).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Faktúru sa nepodarilo uhradiť'));
            return;
        }

        screen.showSnackbar('success', __('Faktúra bola uhradená'));

        dispatch({ type: PAID_MTOKNA_MANUAL_INVOICE, payload: data });
    });
};

export const changeMtoknaManualInvoiceSettings = (screen, id, settings) => {
    return dispatch => request(`/mtokna/setManualInvoiceSettings/${id}`, settings, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Faktúru sa nepodarilo upraviť'));
            return;
        }

        screen.showSnackbar('success', __('Faktúra bola upravená'));

        dispatch({ type: CHANGE_MTOKNA_MANUAL_INVOICE_SETTINGS, payload: { id, settings } });
    });
};

export const cleanMtoknaManualInvoices = () => ({ type: CLEAN_MTOKNA_MANUAL_INVOICES });
